import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { ControlledNumberFormInput } from '#components/form/FormInput.tsx';

import type { MaterialFormContext } from '../model/MaterialFormContext.ts';

type CargoMaterialFieldsProps = {
    materialPrefix: `orders.${number}.materials.${number}` | `materials.${number}`;
};

export const CargoLoadMetricFields = ({ materialPrefix }: CargoMaterialFieldsProps) => {
    const { control } = useFormContext<MaterialFormContext>();
    const intl = useIntl();

    return (
        <div className='display-flex align-items-center gap-20'>
            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.weight',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.weight`}
                className='flex-1-1-0'
                addon='kg'
                control={control}
            />
            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.material.loading-meter',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.loadingMeter`}
                className='flex-1-1-0'
                addon='Ldm'
                control={control}
            />
        </div>
    );
};

export const CargoDimensionFields = ({ materialPrefix }: CargoMaterialFieldsProps) => {
    const { control } = useFormContext<MaterialFormContext>();
    const intl = useIntl();

    return (
        <div className='display-flex align-items-center gap-20'>
            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.length',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.length`}
                className='flex-1-1-0'
                addon='cm'
                control={control}
            />

            <ControlledNumberFormInput
                formGroupClassName='flex-1-1-0'
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.width',
                })}
                name={`${materialPrefix}.width`}
                className='no-controls flex-1-1-0'
                addon='cm'
                control={control}
            />

            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.height',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.height`}
                className='flex-1-1-0'
                addon='cm'
                control={control}
            />
        </div>
    );
};
